/**
 * Feedback Service
 * Handles feedback submission for classification results
 */

import apiClient from 'services/apiClient';
import { API_ENDPOINTS } from 'config/api.config';
import { FeedbackRequest, FeedbackResponse } from 'types/chat.types';

/**
 * Feedback Service Class
 */
class FeedbackService {
  /**
   * Submit feedback for a classification result
   * @param classificationId - The ID of the classification result
   * @param isPositive - True for thumbs up, false for thumbs down
   * @returns Promise with feedback response
   */
  async submitFeedback(
    classificationId: string,
    isPositive: boolean
  ): Promise<FeedbackResponse> {
    console.log('[feedbackService] submitFeedback called', {
      classificationId,
      isPositive,
    });

    try {
      const payload: FeedbackRequest = {
        classification_id: classificationId,
        is_positive: isPositive,
      };

      const response = await apiClient.post<FeedbackResponse>(
        API_ENDPOINTS.FEEDBACK.CREATE,
        payload
      );

      console.log('✅ [feedbackService] Feedback submitted successfully:', response.data);
      return response.data;
    } catch (error: any) {
      console.error('❌ [feedbackService] Failed to submit feedback:', error);

      const errorMessage = error.response?.data?.detail ||
                          error.response?.data?.message ||
                          error.message ||
                          'Failed to submit feedback';

      throw new Error(errorMessage);
    }
  }
}

const feedbackService = new FeedbackService();
export default feedbackService;
